import React, { Component } from 'react';
import AdminFunctions from '../admin/AdminFunctions';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa';
import { MdClear } from 'react-icons/md';
import '../layout/site.css';
import CalsCertsFunctions from '../services/CalsCertsService';
//import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import Moment from 'react-moment';
import moment from 'moment';
import Select from 'react-dropdown-select';
import AuthFunctions from '../services/AuthService';
import FileSaver from 'file-saver';

export class CalsNCerts extends Component {

    static displayName = CalsNCerts.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            fromDate: '',
            toDate: '',
            instruments: [],
            instrumentsOrig: [],
            history: [],
            //isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            show: false,
            showToast: false,
            toastBody: '',
            toastTitle: '',
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClickAll = this.handleClickAll.bind(this);
        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.instruments.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleClickAll() {
    }

    handleClose() {
        this.setState({ show: false, showToast: false });
    }

    handleShow(ticNo, partNo) { 
        this.setState({ show: true, historyPartNo: partNo });
        this.getCalibrationHistory(ticNo, partNo);
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.instruments.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.instruments.length / pageSize) })
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        //this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }

        this.getCalibrations();
    }

    async getCalibrations() {
        var calibrations = await CalsCertsFunctions.getCalibrationsAsync();
       
        if (calibrations.success == true) {
            if (calibrations.data != null) {
                var original = calibrations.data;

                original.forEach((instrument, i) => {
                    if (instrument.partNo == null) instrument.partNo = "";
                    if (instrument.mte == null) instrument.mte = "";
                    if (instrument.serialNo == null) instrument.serialNo = "";
                });

                var filtered = original.slice(0);
                this.setState({ instruments: filtered, instrumentsOrig: original });
            }
        }

    }

    async getCertificateFile(partNo) {
        var filtered = this.state.instruments.filter(function (instrument) {
            return instrument.partNo == partNo;
        });

        if (filtered.length > 0) {
            var instrument = filtered[0];

            var fileAuth = await CalsCertsFunctions.getFileAuth();

            if (fileAuth != null) {
                var authString = fileAuth.id;

                //this.setState({ toastTitle: 'File Downloaded!', toastBody: 'The selected Cert has been downloaded!', showToast: true });
                var ticNumber = instrument.ticNo.replace('TIC', '');
                var partNumber = instrument.partNo.replace('R', '');
                var dateMonth = moment(instrument.calDate).format('MMYY');
                var calDate = moment(instrument.calDate).format('MM-DD-yyyy');

                var anchor = document.createElement("a");
                anchor.href = `/api/calibration/viewcert/${authString}/${ticNumber}_${partNumber}_${dateMonth}.pdf?ticNo=${ticNumber}&partNo=${partNumber}&calDate=${calDate}`;
                anchor.target = '_blank';
                anchor.click();
            } else {
                this.setState({ toastTitle: 'Download Error!', toastBody: 'There was an error downloading the selected Cert!', showToast: true });
            }

            //var certificate = await CalsCertsFunctions.getCertificateFileAsync(instrument);

            //if (certificate != null) {
            //    if (certificate.ok == true && certificate.status == 200) {
            //        certificate.blob().then((data) => {
            //            //this.setState({ toastTitle: 'File Downloaded!', toastBody: 'The selected Cert has been downloaded!', showToast: true });
            //            var ticNumber = instrument.ticNo.replace('TIC', '');
            //            var partNumber = instrument.partNo.replace('R', '');
            //            var dateMonth = moment(instrument.calDate).format('MMYY');
            //            var calDate = moment(instrument.calDate).format('MM-dd-yyyy');

            //            var anchor = document.createElement("a");
            //            anchor.href = `/api/calibration/viewcert/${ticNumber}_${partNumber}_${dateMonth}.pdf?ticNo=${ticNumber}&partNo=${partNumber}&calDate=${calDate}`;
            //            anchor.target = '_blank';
            //            anchor.click();

            //            //window.open(url);

            //            //anchor.href = url;
            //            ////anchor.download = `${ticNumber}${partNumber}${dateMonth}.pdf`;
            //            //anchor.filename = `${ticNumber}${partNumber}${dateMonth}.pdf`;
            //            //anchor.target = '_blank';
            //            //anchor.click();
            //            //setTimeout(function () {
            //            //    window.URL.revokeObjectURL(url);
            //            //}, 0);
            //        }).catch((error) => {
            //            console.log(error);
            //            this.setState({ toastTitle: 'Download Error!', toastBody: 'There was an error downloading the selected Cert!', showToast: true });
            //        });
            //    } else if (certificate.status == 204) {
            //        this.setState({ toastTitle: 'Cert Unavailable!', toastBody: 'The selected Cert could not be located!', showToast: true });
            //    }
            //}
        }
    }

    async getCertificateFileHistory(ticNo, fileName) {
        var historyPartNo = this.state.historyPartNo;
        var filtered = this.state.instruments.filter(function (instrument) {
            return instrument.partNo == historyPartNo;
        });

        if (filtered.length > 0) {
            var instrument = filtered[0];

            var fileAuth = await CalsCertsFunctions.getFileAuth();

            if (fileAuth != null) {
                var authString = fileAuth.id;

            //var certificate = await CalsCertsFunctions.getPastCertificateFileAsync(ticNo, fileName);

            //if (certificate != null) {
            //    if (certificate.ok == true && certificate.status == 200) {
            //        certificate.blob().then((data) => {
                        //this.setState({ toastTitle: 'File Downloaded!', toastBody: 'The selected Cert has been downloaded!', showToast: true });
                        var ticNumber = instrument.ticNo.replace('TIC', '');
                        var partNumber = instrument.partNo.replace('R', '');
                        var dateMonth = fileName.slice(-4);

                        var anchor = document.createElement("a");
                        anchor.href = `/api/calibration/viewcert/${authString}/${ticNumber}_${partNumber}_${dateMonth}.pdf?ticNo=${ticNumber}`;
                        anchor.target = '_blank';
                        anchor.click();
                        //window.URL.revokeObjectURL(url);
        //            }).catch((error) => {
        //                console.log(error);
        //                this.setState({ toastTitle: 'Download Error!', toastBody: 'There was an error downloading the selected Cert!', showToast: true });
        //            });
        //        } else if (certificate.status == 204) {
        //            this.setState({ toastTitle: 'Cert Unavailable!', toastBody: 'The selected Cert could not be located!', showToast: true });
        //        }
        //    }
            } else {
                this.setState({ toastTitle: 'Download Error!', toastBody: 'There was an error downloading the selected Cert!', showToast: true });
            }
        }
    }

    async getCertificateZipFile() {
        var filtered = this.state.instruments.filter(function (instrument) {
            return instrument.selected == true;
        });

        if (filtered.length > 0) {
            this.setState({ toastTitle: 'Packaging Files!', toastBody: 'The selected Certs are being packaged for download.  This may take a while to complete.  If there are fewer files provided than were selected, there were Certs that were not available.', showToast: true });

            var certificate = await CalsCertsFunctions.getCertificateZipFileAsync(filtered);

            if (certificate != null) {
                if (certificate.ok == true && certificate.status == 200) {
                    certificate.blob().then((data) => {
                        console.log(data);
                        var date = new Date().toLocaleDateString();
                        var url = window.URL.createObjectURL(data);
                        var anchor = document.createElement("a");
                        anchor.href = url;
                        anchor.download = 'SelectedCerts-' + date + '.zip';
                        anchor.click();
                        window.URL.revokeObjectURL(url);
                    }).catch((error) => { console.log(error); });
                }
            }
        }
    }

    async getCalibrationHistory(ticNo, partNo) {
        var calibrations = await CalsCertsFunctions.getCalibrationHistoryAsync(ticNo, partNo);

        if (calibrations.success == true) {
            if (calibrations.data != null) {
                calibrations.data.sort(function (a, b) {
                    var dateA = new Date(a.cert_date);
                    var dateB = new Date(b.cert_date);

                    return dateB - dateA;
                });

                this.setState({ history: calibrations.data });
            }
        }

    }

    //setWindowDimensions = () => {
    //    this.setState({
    //        height: window.innerHeight,
    //        width: window.innerWidth
    //    });
    //};

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchInstruments();
        }
    }

    handleCheckAll(event) {
        var instruments = this.state.instruments;
        var checked = event.target.checked;

        instruments.forEach((instrument, index) => {
            instrument.selected = checked;
        });

        this.setState({ instruments: instruments });
    }

    handleSelectClick(event, partNo) {
        this.handleCheck(event.target.checked, partNo);
    }

    handleCheck(checked, partNo) {
        var instruments = this.state.instruments;
        var filtered = instruments.filter(function (instrument) {
            return instrument.partNo == partNo;
        });

        if (filtered.length > 0) {
            filtered[0].selected = checked;
        }

        this.setState({ instruments: instruments });
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.instruments.slice(indexOfFirstItem, indexOfLastItem);

        const selectedItems = this.state.instruments.filter(function (instrument) {
            return instrument.selected != null && instrument.selected == true; 
        }).map((instrument) => 
            ({label: instrument.partNo + ' - ' + instrument.description, value: instrument.partNo})
        ).sort(function (a, b) {
                return (a.value.localeCompare(b.value));
        });
                
        //const [show, setShow] = Component(false);

        // const handleClose = () => this.setState({ show: false });
        // const handleShow = () => this.setState({ show: true });

        const customContentRenderer = () => {
            return (
                <div>{selectedItems.length} Instruments Selected</div>
            );
        }

        const customNoDataRenderer = () => {
            return (
                <div>0 Instruments Selected</div>
            );
        }

        const customItemRenderer = ({ item, itemIndex, props, state, methods }) => (
            <div style={{width: '100%'}}>
                <div style={{padding: '5px', float: 'left'}}>
                    {item.label}
                </div>
                <div style={{padding: '5px', float: 'right'}}>
                    <MdClear
                        onClick={() => this.handleCheck(false, item.value)}
                        color={'#0a58ca'}
                    />
                </div>
            </div>
        );

        const renderItems = currentItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    <td><a href="javascript:void(0)" onClick={(e) => this.getCertificateFile(instrument.partNo)}>View</a></td>
                    <td><a href="javascript:void(0)" onClick={(e) => this.handleShow(instrument.ticNo, instrument.partNo)}>Show</a></td>
                    <td>
                        <Input
                            type='checkbox'
                            onChange={(e) => this.handleSelectClick(e, instrument.partNo)}
                            style={{ marginLeft: '0.0rem' }}
                            checked={instrument.selected}
                            className='centerCheckBoxInput'
                        />
                    </td>
                    <td>{instrument.partNo}</td>
                    <td>{instrument.mte}</td>
                    <td>{instrument.description}</td>
                    <td style={{ maxWidth: '100px' }}>{instrument.manufacturer}</td>
                    <td style={{ maxWidth: '100px' }}>{instrument.model}</td>
                    <td style={{ maxWidth: '100px' }}>{instrument.serialNo}</td>
                    <td style={{ maxWidth: '100px' }}>{instrument.department}</td>
                    <td>{instrument.calDate != null && <Moment format="M/D/YY">{instrument.calDate}</Moment>}</td>
                    <td>{instrument.expDate != null && <Moment format="M/D/YY">{instrument.expDate}</Moment>}</td>
                </tr>
            )
        });

        const renderItems2 = this.state.history.map((cert, i) => {
            return (
                <tr key={i}>
                    <td style={{ textAlign: 'center' }}><a href="javascript:void(0)" onClick={(e) => this.getCertificateFileHistory(cert.ticNo, cert.filename)}>View</a></td>
                    <td style={{ textAlign: 'center' }}>{cert.cal_date != null && <Moment format="M/D/YYYY">{cert.cal_date}</Moment>}</td>
                    <td style={{ textAlign: 'center' }}>{cert.cert_date != null && <Moment format="M/YYYY">{cert.cert_date}</Moment>}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.instruments.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Cals &amp; Certs</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row style={{ marginTop: '20px' }}>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <label style={{width: '175px'}}></label>
                                </div>
                                <div className='col' style={{ maxWidth: '200px' }}><label style={{ width: '175px' }}>Cal Date From</label></div>
                                <div className='col' style={{ maxWidth: '200px' }}>Cal Date To</div>
                                <div className='col' style={{ maxWidth: '200px' }}></div>
                                <div className='col'></div>
                            </Row>
                            <Row>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ search: e.target.value })}
                                        name='search'
                                        id='search'
                                        style={{ width: '175px' }}
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                        placeholder='R#, M&TE, Serial#'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <Input
                                        type='date'
                                        onChange={(e) => this.setState({ fromDate: e.target.value })}
                                        name='DateFrom'
                                        id='DateFrom'
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                        placeholder='From Date'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <Input
                                        type='date'
                                        onChange={(e) => this.setState({ toDate: e.target.value })}
                                        name='DateTo'
                                        id='DateTo'
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                        placeholder='To Date'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '125px' }}>
                                    <Button
                                        color='primary'
                                        className='standardButton'
                                        style={{ width: '125px' }}
                                        onClick={(e) => { this.searchInstruments() }}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Search
                                    </Button>
                                </div>
                                <div className='col' style={{ textAlign: 'right' }}>
                                    <Button
                                        color='primary'
                                        className='standardButton'
                                        onClick={() => this.getCertificateZipFile()}
                                        style={{ width: '175px' }}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Download Certs
                                    </Button>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    
                    {this.state.instruments.length !== 0 && (
                    <Row className='row-20'>
                        <div className='col'>
                            <Select
                                className='form-control'
                                style={{width:'500px', marginRight: '20px', borderRadius: '0.25rem'}}
                                placeholder=""
                                noDataRenderer={customNoDataRenderer}
                                contentRenderer={customContentRenderer}
                                itemRenderer={customItemRenderer}
                                onChange={() => undefined}
                                values={selectedItems}
                                loading={this.state.loading}
                                options={selectedItems}
                                />                        
                        </div>
                        <div className='col' style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center' }}>
                            <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                {renderPageNumbers}
                            </select>
                            <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </Row>
                    
                    )}
                    <Row style={{ marginTop: '20px' }}>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>
                                            Cert
                                        </th>
                                        <th>
                                            History
                                        </th>
                                        <th className='noBanner centerCheckBoxTD'>
                                            <div>
                                                <Input
                                                    type='checkbox'
                                                    onChange={(e) => this.handleCheckAll(e)} //Call a function to check all the checkboxes.
                                                    style={{ marginLeft: '0.0rem' }}
                                                    className='centerCheckBoxInput'
                                                />
                                            </div>

                                        </th>
                                        <th>
                                            R#
                                            <FaSort
                                                color={this.state.sort.column === 'partNo' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('partNo')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            M&TE#
                                            <FaSort
                                                color={this.state.sort.column === 'mte' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('mte')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Description
                                            <FaSort
                                                color={this.state.sort.column === 'description' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('description')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Mfg
                                            <FaSort
                                                color={this.state.sort.column === 'manufacturer' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('manufacturer')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th style={{ maxWidth: '100px' }}>
                                            Model
                                            <FaSort
                                                color={this.state.sort.column === 'model' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('model')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Serial #
                                            <FaSort
                                                color={this.state.sort.column === 'serialNo' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('serialNo')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Dept
                                            <FaSort
                                                color={this.state.sort.column === 'department' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('department')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Cal. Date
                                            <FaSort
                                                color={this.state.sort.column === 'calDate' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('calDate')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Cal. Due
                                            <FaSort
                                                color={this.state.sort.column === 'expDate' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('expDate')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                        <h5>No Results Found</h5>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {this.state.instruments.length !== 0 && (
                        <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                            <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                {renderPageNumbers}
                            </select>
                            <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>

                        </div>
                    )}
                </Container>
                <Modal show={this.state.showToast} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>{this.state.toastTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.toastBody}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    {/*TODO: Add closeButton to Header... and get it to display!*/}
                    <Modal.Header > 
                        <Modal.Title>Historical Certificates for {this.state.historyPartNo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><Table responsive>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>
                                    Cert
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Cal. Date
                                    <FaSort
                                        color={this.state.sort.column === 'calDate' ? '#0a58ca' : 'black'}
                                        onClick={() => this.handleSort('calDate')}
                                        className='sort-button'
                                    />
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Cert Date
                                    <FaSort
                                        color={this.state.sort.column === 'expDate' ? '#0a58ca' : 'black'}
                                        onClick={() => this.handleSort('expDate')}
                                        className='sort-button'
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.loading === true && this.state.loadingDocument === false ? (
                                <tr>
                                    <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                        <Spinner color="primary" children='' />
                                    </td>
                                </tr>

                            ) : (
                                <>
                                    {!this.state.noResults ? (
                                        <>
                                            {renderItems2}
                                        </>
                                    ) : (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <h5>No Results Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                    </Table>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    // instruments

    async searchInstruments() {
        var search = this.state.search;
        var fromDate = this.state.fromDate;
        var toDate = this.state.toDate;
        var instruments = this.state.instrumentsOrig;

        if (search == null || search == "") {
            if (fromDate !== null && fromDate !== '') {
                var from = new Date(fromDate);
                instruments = instruments.filter(function (instrument) {
                    var calDate = new Date(instrument.calDate);
                    return (calDate.getTime() >= from.getTime());
                });
            }
            if (toDate !== null && toDate !== '') {
                var to = new Date(toDate);
                var endOfDay = 24 * 60 * 60 * 1000;
                instruments = instruments.filter(function (instrument) {
                    var calDate = new Date(instrument.calDate);
                    return (calDate.getTime() <= to.getTime() + endOfDay);
                });
            }
            this.setState({ instruments: instruments });
        } else {
            var instruments = instruments.filter(function (instrument) {
                return instrument.partNo.includes(search) || instrument.mte.includes(search) || instrument.serialNo.includes(search);
            });

            if (fromDate !== null && fromDate !== '') {
                var from = new Date(fromDate);
                instruments = instruments.filter(function (instrument) {
                    var calDate = new Date(instrument.calDate);
                    return (calDate.getTime() >= from.getTime());
                });
            }
            if (toDate !== null && toDate !== '') {
                var to = new Date(toDate);
                var endOfDay = 24 * 60 * 60 * 1000;
                instruments = instruments.filter(function (instrument) {
                    var calDate = new Date(instrument.calDate);
                    return (calDate.getTime() <= to.getTime() + endOfDay);
                });
            }
            this.setState({ instruments: instruments });
        }
    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.instruments;

        data.sort(function (a, b) {
            if (!a[column]) return -1;

            if (!b[column]) return +1;

            return (a[column] instanceof Date ? (b[column] - a[column]) : a[column].localeCompare(b[column]));
        });

        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            instruments: data,
            sort: {
                column,
                direction
            }
        })
    }
}
